// Aurora Innovation, Inc. Proprietary and Confidential. Copyright 2026.
import { background } from '../../tokens/themeColors/background';
import { border } from '../../tokens/themeColors/border';
export var ratingColors = function(mode) {
    var bg = background(mode);
    var bd = border(mode);
    return {
        default: {
            background: bg.level0,
            border: bd.heavy,
            fill: bg.status.infoBold
        },
        hover: {
            background: bg.level300,
            border: bd.active,
            fill: bg.status.hover.infoBold
        }
    };
};

//# sourceMappingURL=ratingColors.js.map